module.exports = __webpack_public_path__ + "img/5-2.cf904e93.svg";